<template>
  <AppPageSection class="app-reviewable-section">
    <header class="s-header">
      <h3 class="s-header-title">{{ headerTitle }}</h3>
    </header>

    <section class="form-section">
      <header class="fs-header">
        <h4 class="fs-header-title">Write your comment</h4>
      </header>
      <AppReviewableForm :textarea-min-h="50" @submit="$emit('store-reviewable', $event)" />
    </section>

    <AppReviewableList v-if="items.length" class="items-list" :reviews="items" />
  </AppPageSection>
</template>

<script>
import AppPageSection from '@/components/AppPageSection.vue';
import AppReviewableList from '@/components/AppReviewableList.vue';
import AppReviewableForm from '@/components/AppReviewableForm.vue';
import AppSeparatorLine from '@/components/AppSeparatorLine.vue';

export default {
  name: 'AppReviewableSection',
  components: { AppSeparatorLine, AppReviewableForm, AppPageSection, AppReviewableList },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    name: {
      type: String,
      default: 'review',
    },
  },
  computed: {
    headerTitle() {
      const pluralName = `${this.name}s`;

      return this.items.length ? `${pluralName} (${this.items.length})` : `No ${pluralName} yet`;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.app-reviewable-section {
  max-width: 760px;
  margin-left: auto;
  margin-right: auto;

  .s-header {
    margin-bottom: 48px;
  }

  .s-header-title {
    font-size: 24px;
    font-weight: 600;
    text-transform: capitalize;
  }

  .form-section {
    .fs-header {
      margin-bottom: 16px;
    }

    .fs-header-title {
      margin-bottom: 0;
      font-size: 18px;
      font-weight: 500;
    }
  }

  .items-list {
    margin-top: 56px;
  }
}
</style>
